import { element } from '../../core/elements';
import { GridColumns } from './GridColumns';
import { GridRows } from './GridRows';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Grid(_ref) {
  let {
    top,
    left,
    xScale,
    yScale,
    width,
    height,
    stroke,
    strokeWidth,
    strokeDasharray,
    numTicksRows,
    numTicksColumns,
    rowLineStyle,
    columnLineStyle,
    xOffset,
    yOffset,
    rowTickValues,
    columnTickValues,
    hide = false
  } = _ref;
  if (hide) return null;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      top: top,
      left: left,
      gridArea: 'plot'
    },
    children: [/*#__PURE__*/_jsx(GridRows, {
      scale: yScale,
      width: width,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      numTicks: numTicksRows,
      lineStyle: rowLineStyle,
      offset: yOffset,
      tickValues: rowTickValues
    }), /*#__PURE__*/_jsx(GridColumns, {
      scale: xScale,
      height: height,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      numTicks: numTicksColumns,
      lineStyle: columnLineStyle,
      offset: xOffset,
      tickValues: columnTickValues
    })]
  });
}
const _Grid = element(Grid);
export { _Grid as Grid };